<template>
    <div>
        <div class="news-filter primary-text primary-border d-flex flex-row align-items-center">
            <button class="news-filter__button primary-text primary-border"
                    aria-haspopup="dialog"
                    @click="open = true"
            >
                <span class="mr-2" v-html="icon"></span> <span>{{ buttonLabel }}</span>
            </button>
            <span v-show="valuesPresentation" class="news-filter__long-dash primary-background"></span>
            <span class="news-filter__selected-category primary-text">{{ valuesPresentation }}</span>
        </div>
        <modal v-model="open">
            <div class="container-fluid w-100 h-100 d-flex flex-column align-items-stretch justify-content-center">
                <div class="row">
                    <news-select v-for="(option, idx) of options"
                                 :key="idx.toString()"
                                 :options="option"
                                 :label="labels[idx]"
                                 :value="values[idx]"
                                 class="news-filter__select"
                                 @select="select($event, idx)">
                    </news-select>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import NewsSelect from './NewsFilterSelect';
    import FilterIcon from './filter-icon.txt';

    export default {
        components: { NewsSelect },
        props: {
            options: {
                type: Array,
                required: true,
            },
            values: {
                type: Array,
                required: true,
            },
            buttonLabel: {
                type: String,
                required: true,
            },
            labels: {
                type: Array,
                required: true,
            },
        },
        data () {
            return {
                icon: FilterIcon,
                open: false,
            };
        },
        computed: {
            valuesPresentation () {
                return this.values
                           .map((v, i) => v ? this.options[i].find(o => o.value === v) : null)
                           .filter(v => typeof v === 'object' && v !== null)
                           .map(v => v.label)
                           .filter(v => !!v)
                           .join(', ');
            },
        },
        methods: {
            select (value, index) {
                this.$emit('select', [ value.value, index ]);
            },
        },
    };
</script>
